import * as React from 'react';
import { useFeatureFlagWithStatus } from '../../../shared/featureFlags/useFeatureFlagWithStatus';
import { FeatureFlagKeys } from '../../../shared/featureFlags/featureFlagKeys';
import { UserPreferenceKeys } from '../../../shared/userPreferences/UserPreferencesApi';
import { useUserPreferencesQuery } from '../../../shared/userPreferences/useUserPreferencesQuery';
import CreateOrderPageV1 from './v1/CreateOrderPage';
import CreateOrderPageV2 from './v2/CreateOrderPage';
import { CreateOrderPageSwitch } from './CreateOrderPageSwitch';
import { chooseCreateOrderPageVersion } from './createOrderPageVersion';

function CreateOrderPageDelegate() {
    let { value: isOptInAllowed, isLoading: isFlagLoading } = useFeatureFlagWithStatus(
        FeatureFlagKeys.CreateOrderV2OptIn,
        false
    );
    let preferences = useUserPreferencesQuery(isOptInAllowed);

    if (isFlagLoading || (isOptInAllowed && preferences.isLoading)) {
        return null;
    }

    let savedChoice = preferences.data
        ? preferences.data[UserPreferenceKeys.CreateOrderPageVersion]
        : undefined;
    let version = chooseCreateOrderPageVersion(isOptInAllowed, savedChoice);

    return (
        <>
            {isOptInAllowed && version === 'v1' && (
                <CreateOrderPageSwitch currentVersion={version} />
            )}
            {version === 'v2' ? (
                <CreateOrderPageV2
                    notice={isOptInAllowed && <CreateOrderPageSwitch currentVersion={version} />}
                />
            ) : (
                <CreateOrderPageV1 />
            )}
        </>
    );
}

export default CreateOrderPageDelegate;
